/**
 * When the student still has at least this many AINA free doubts, show the
 * “Upload. Send. Solve.” intro modal before opening the camera doubt flow.
 */
export const AINA_CAMERA_DOUBT_ONBOARDING_MIN_FREE_DOUBTS = 5;

export function shouldShowAinaCameraDoubtOnboarding(
  noOfDoubts: number,
): boolean {
  return noOfDoubts >= AINA_CAMERA_DOUBT_ONBOARDING_MIN_FREE_DOUBTS;
}
